import { atom } from 'recoil';

export const DataVr360State = atom({
    key: 'DataVr360State',
    default: null
});